import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CustomerSiteAdministrationControllerService } from '@app/generated/api';
import { CustomerSiteDto } from '@app/generated/model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AddCustomerSiteComponent } from './add-customer-site/add-customer-site.component';

@Component({
  selector: 'app-customer-sites',
  templateUrl: './customer-sites.component.html',
  styleUrls: ['./customer-sites.component.scss'],
  standalone: false,
})
export class CustomerSitesComponent implements OnInit, OnDestroy {
  displayColumns: string[] = ['siteCode', 'siteName', 'actions'];
  dataSource: MatTableDataSource<CustomerSiteDto> = new MatTableDataSource();
  filter = '';
  loading = false;
  private readonly destroy$ = new Subject<void>();

  @ViewChild(MatSort, { static: false }) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  constructor(
    private customerSiteService: CustomerSiteAdministrationControllerService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.loadCustomerSites();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onRefresh(): void {
    this.loadCustomerSites();
  }

  onFilter(filter: string): void {
    this.filter = filter;
    this.dataSource.filter = filter.trim().toLowerCase();
  }

  onAdd(): void {
    this.dialog
      .open(AddCustomerSiteComponent)
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result) {
          this.loadCustomerSites();
        }
      });
  }

  onDelete(item: CustomerSiteDto): void {
    const siteCode = item?.siteCode;
    if (!siteCode) {
      return;
    }

    const shouldDelete = window.confirm(`Delete customer site mapping \"${siteCode}\"?`);
    if (!shouldDelete) {
      return;
    }

    this.customerSiteService
      .deleteCustomerSite(siteCode)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.loadCustomerSites(),
        error: (err) => console.error('Error deleting customer site:', err),
      });
  }

  private loadCustomerSites(): void {
    this.loading = true;
    this.customerSiteService
      .getCustomerSites()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (customerSites) => {
          this.dataSource.data = customerSites ?? [];
          this.loading = false;
        },
        error: () => {
          this.dataSource.data = [];
          this.loading = false;
        },
      });
  }
}
